import { lazy, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import GenericSolutionsPage from "./GenericSolutionsPage";
import { isAiOverviewCategory } from "./ai-business/route";

// AI业务首页体积较大（内联 HTML 片段 + Scoped_CSS），仅在命中分流时才加载其 chunk
const AiBusinessOverview = lazy(() => import("./ai-business/AiBusinessOverview"));

/**
 * `/solutions` 渲染分流：
 * - `?category=ai-business`（精确匹配）→ AI业务首页；
 * - 其余（无参数、其他分类、大小写不符、空串等）→ 通用解决方案页（原 page.tsx 的内容）。
 *
 * 两个分支是互斥的不同组件，各自的 Hooks 调用互不影响；Navbar / Footer 由 App.tsx 统一提供。
 */
export default function SolutionsPage() {
  const [searchParams] = useSearchParams();

  if (isAiOverviewCategory(searchParams.get("category"))) {
    return (
      <Suspense fallback={<div className="min-h-screen" aria-busy="true" />}>
        <AiBusinessOverview />
      </Suspense>
    );
  }

  return <GenericSolutionsPage />;
}
